export default __webpack_public_path__ + "static/media/09.ac9e4668.png";